import * as types from "../services/adminActionType";
import initialState from "../../../store/initialState";

const regionReducer = (state = initialState.admin, action) => {
  switch (action.type) {
    //Region cases
    case types.FETCH_REGIONS_REQUEST:
      return { ...state, isRegionLoading: true };
    case types.FETCH_REGIONS_SUCCESS:
      return {
        ...state,
        isRegionLoading: false,
        regions: action.payload?.lstRegion,
      };
    case types.FETCH_REGIONS_FAILURE:
      return { ...state, isRegionLoading: false, regions: [] };

    case types.DELETE_REGION_REQUEST:
      return { ...state, isRegionLoading: true };
    case types.DELETE_REGION_SUCCESS:
      return { ...state, isRegionLoading: false };
    case types.DELETE_REGION_FAILURE:
      return { ...state, isRegionLoading: false };

    case types.SAVE_REGION_REQUEST:
      return { ...state, isRegionLoading: true, isRegionSaved: false };
    case types.SAVE_REGION_SUCCESS:
      return { ...state, isRegionLoading: false, isRegionSaved: true };
    case types.SAVE_REGION_FAILURE:
      return { ...state, isRegionLoading: false, isRegionSaved: false };

    case types.FETCH_REGION_BY_ID_REQUEST:
      return { ...state, isRegionLoading: true };
    case types.FETCH_REGION_BY_ID_SUCCESS:
      return {
        ...state,
        isRegionLoading: false,
        selectedRegion: action.payload,
      };
    case types.FETCH_REGION_BY_ID_FAILURE:
      return { ...state, isRegionLoading: false, selectedRegion: null };

    case types.UPDATE_REGION_REQUEST:
      return { ...state, isRegionLoading: true };
    case types.UPDATE_REGION_SUCCESS:
      return { ...state, isRegionLoading: false, selectedRegion: null };
    case types.UPDATE_REGION_FAILURE:
      return { ...state, isRegionLoading: false };

    case types.ACTIVATE_DEACTIVATE_REGION_REQUEST:
      return { ...state, isRegionLoading: true };
    case types.ACTIVATE_DEACTIVATE_REGION_SUCCESS:
      return { ...state, isRegionLoading: false };
    case types.ACTIVATE_DEACTIVATE_REGION_FAILURE:
      return { ...state, isRegionLoading: false };

    //National cases
    case types.FETCH_NATIONALS_REQUEST:
      return { ...state, isNationalLoading: true };
    case types.FETCH_NATIONALS_SUCCESS:
      return {
        ...state,
        isNationalLoading: false,
        nationals: action.payload?.lstNational,
      };
    case types.FETCH_NATIONALS_FAILURE:
      return { ...state, isNationalLoading: false, nationals: [] };

    case types.SAVE_NATIONAL_REQUEST:
      return { ...state, isNationalLoading: true, isNationalSaved: false };
    case types.SAVE_NATIONAL_SUCCESS:
      return { ...state, isNationalLoading: false, isNationalSaved: true };
    case types.SAVE_NATIONAL_FAILURE:
      return { ...state, isNationalLoading: false, isNationalSaved: false };

    case types.FETCH_NATIONAL_BY_ID_REQUEST:
      return { ...state, isNationalLoading: true };
    case types.FETCH_NATIONAL_BY_ID_SUCCESS:
      return {
        ...state,
        isNationalLoading: false,
        selectedNational: action.payload,
      };
    case types.FETCH_NATIONAL_BY_ID_FAILURE:
      return { ...state, isNationalLoading: false, selectedNational: null };

    case types.ACTIVATE_DEACTIVATE_NATIONAL_REQUEST:
      return { ...state, isNationalLoading: true };
    case types.ACTIVATE_DEACTIVATE_NATIONAL_SUCCESS:
      return { ...state, isNationalLoading: false };
    case types.ACTIVATE_DEACTIVATE_NATIONAL_FAILURE:
      return { ...state, isNationalLoading: false };

    //RPCE cases
    case types.FETCH_RPCE_REQUEST:
      return { ...state, isRPCELoading: true };
    case types.FETCH_RPCE_SUCCESS:
      return { ...state, isRPCELoading: false, RPCE: action.payload?.listRPCE };
    case types.FETCH_RPCE_FAILURE:
      return { ...state, isRPCELoading: false, RPCE: [] };

    case types.DELETE_RPCE_REQUEST:
      return { ...state, isRPCELoading: true };
    case types.DELETE_RPCE_SUCCESS:
      return { ...state, isRPCELoading: false };
    case types.DELETE_RPCE_FAILURE:
      return { ...state, isRPCELoading: false };

    case types.SAVE_RPCE_REQUEST:
      return { ...state, isRPCELoading: true };
    case types.SAVE_RPCE_SUCCESS:
      return { ...state, isRPCELoading: false };
    case types.SAVE_RPCE_FAILURE:
      return { ...state, isRPCELoading: false };

    case types.FETCH_RPCE_BY_ID_REQUEST:
      return { ...state, isRPCELoading: true };
    case types.FETCH_RPCE_BY_ID_SUCCESS:
      return { ...state, isRPCELoading: false, selectedRPCE: action.payload };
    case types.FETCH_RPCE_BY_ID_FAILURE:
      return { ...state, isRPCELoading: false, selectedRPCE: null };

    case types.ACTIVATE_DEACTIVATE_RPCE_REQUEST:
      return { ...state, isRPCELoading: true };
    case types.ACTIVATE_DEACTIVATE_RPCE_SUCCESS:
      return { ...state, isRPCELoading: false };
    case types.ACTIVATE_DEACTIVATE_RPCE_FAILURE:
      return { ...state, isRPCELoading: false };

    //Worklist cases
    case types.FETCH_WORKLIST_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.FETCH_WORKLIST_SUCCESS:
      return {
        ...state,
        isWorkListLoading: false,
        worklist: action.payload?.listWorkList || [],
      };
    case types.FETCH_WORKLIST_FAILURE:
      return { ...state, isWorkListLoading: false, worklist: [] };

    case types.DELETE_WORKLIST_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.DELETE_WORKLIST_SUCCESS:
      return { ...state, isWorkListLoading: false };
    case types.DELETE_WORKLIST_FAILURE:
      return { ...state, isWorkListLoading: false };

    case types.DROPDOWN_WORKLIST_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.DROPDOWN_WORKLIST_SUCCESS:
      return {
        ...state,
        isWorkListLoading: false,
        workListDropdown: action.payload || [],
      };
    case types.DROPDOWN_WORKLIST_FAILURE:
      return { ...state, isWorkListLoading: false, workListDropdown: [] };

    case types.SAVE_WORKLIST_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.SAVE_WORKLIST_SUCCESS:
      return { ...state, isWorkListLoading: false };
    case types.SAVE_WORKLIST_FAILURE:
      return { ...state, isWorkListLoading: false };

    case types.FETCH_WORKLIST_BY_ID_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.FETCH_WORKLIST_BY_ID_SUCCESS:
      return {
        ...state,
        isWorkListLoading: false,
        selectedWorkList: action.payload,
      };
    case types.FETCH_WORKLIST_BY_ID_FAILURE:
      return { ...state, isWorkListLoading: false, selectedWorkList: null };

    // Worklist Definition cases
    case types.FETCH_WORKLIST_DEFINITION_REQUEST:
      return { ...state, isWorklistDefinitionLoading: true };
    case types.FETCH_WORKLIST_DEFINITION_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        worklistDefinition: action.payload?.listWorkList || [],
      };
    case types.FETCH_WORKLIST_DEFINITION_FAILURE:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        worklistDefinition: [],
      };

    case types.DROPDOWN_WORKLIST_DEFINITION_TYPE_REQUEST:
      return { ...state, isWorklistDefinitionLoading: true };
    case types.DROPDOWN_WORKLIST_DEFINITION_TYPE_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        worklistDefinitionTypeDropdown:
          action.payload?.dropdownItems || action.payload || [],
      };
    case types.DROPDOWN_WORKLIST_DEFINITION_TYPE_FAILURE:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        worklistDefinitionTypeDropdown: [],
      };

    case types.DROPDOWN_WORKLIST_DEFINITION_FACILITY_REQUEST:
      return { ...state, isWorklistDefinitionLoading: true };
    case types.DROPDOWN_WORKLIST_DEFINITION_FACILITY_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        worklistDefinitionFacilityDropdown:
          action.payload?.dropdownItems || action.payload || [],
      };
    case types.DROPDOWN_WORKLIST_DEFINITION_FACILITY_FAILURE:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        worklistDefinitionFacilityDropdown: [],
      };

    case types.SAVE_WORKLIST_DEFINITION_REQUEST:
      return {
        ...state,
        isWorklistDefinitionLoading: true,
        isWorklistDefinitionSaved: false,
        worklistDefinitionSaveError: null,
      };
    case types.SAVE_WORKLIST_DEFINITION_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        isWorklistDefinitionSaved: true,
        worklistDefinitionSaveError: null,
      };
    case types.SAVE_WORKLIST_DEFINITION_FAILURE:
      return {
        ...state,
        isWorklistDefinitionLoading: false,
        isWorklistDefinitionSaved: false,
        worklistDefinitionSaveError: action.payload,
      };

    case types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_REQUEST:
      return { ...state, isWorklistDefinitionLoading: true };
    case types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_SUCCESS:
      return { ...state, isWorklistDefinitionLoading: false };
    case types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_FAILURE:
      return { ...state, isWorklistDefinitionLoading: false };

    case types.DELETE_WORKLIST_DEFINITION_REQUEST:
      return { ...state, isWorklistDefinitionLoading: true };

    case types.DELETE_WORKLIST_DEFINITION_SUCCESS:
      return { ...state, isWorklistDefinitionLoading: false };

    case types.DELETE_WORKLIST_DEFINITION_FAILURE:
      return { ...state, isWorklistDefinitionLoading: false };

    // Worklist Group cases
    case types.FETCH_WORKLIST_GROUP_REQUEST:
      return { ...state, isWorklistGroupLoading: true };
    case types.FETCH_WORKLIST_GROUP_SUCCESS:
      return {
        ...state,
        isWorklistGroupLoading: false,
        worklistGroup: action.payload?.listWorklistGroup || [],
      };
    case types.FETCH_WORKLIST_GROUP_FAILURE:
      return {
        ...state,
        isWorklistGroupLoading: false,
        worklistGroup: [],
      };

    case types.DROPDOWN_WORKLIST_GROUP_WORKLIST_REQUEST:
      return { ...state, isWorklistGroupLoading: true };
    case types.DROPDOWN_WORKLIST_GROUP_WORKLIST_SUCCESS:
      return {
        ...state,
        isWorklistGroupLoading: false,
        worklistGroupWorklistDropdown:
          action.payload?.dropdownItems || action.payload || [],
      };
    case types.DROPDOWN_WORKLIST_GROUP_WORKLIST_FAILURE:
      return {
        ...state,
        isWorklistGroupLoading: false,
        worklistGroupWorklistDropdown: [],
      };

    case types.SAVE_WORKLIST_GROUP_REQUEST:
      return {
        ...state,
        isWorklistGroupLoading: true,
        isWorklistGroupSaved: false,
        worklistGroupSaveError: null,
      };
    case types.SAVE_WORKLIST_GROUP_SUCCESS:
      return {
        ...state,
        isWorklistGroupLoading: false,
        isWorklistGroupSaved: true,
        worklistGroupSaveError: null,
      };
    case types.SAVE_WORKLIST_GROUP_FAILURE:
      return {
        ...state,
        isWorklistGroupLoading: false,
        isWorklistGroupSaved: false,
        worklistGroupSaveError: action.payload,
      };

    case types.ACTIVATE_DEACTIVATE_WORKLIST_GROUP_REQUEST:
      return { ...state, isWorklistGroupLoading: true };
    case types.ACTIVATE_DEACTIVATE_WORKLIST_GROUP_SUCCESS:
      return { ...state, isWorklistGroupLoading: false };
    case types.ACTIVATE_DEACTIVATE_WORKLIST_GROUP_FAILURE:
      return { ...state, isWorklistGroupLoading: false };

    case types.DELETE_WORKLIST_GROUP_REQUEST:
      return { ...state, isWorklistGroupLoading: true };
    case types.DELETE_WORKLIST_GROUP_SUCCESS:
      return { ...state, isWorklistGroupLoading: false };
    case types.DELETE_WORKLIST_GROUP_FAILURE:
      return { ...state, isWorklistGroupLoading: false };

    case types.FETCH_TAG_CATEGORY_CONFIGURATION_REQUEST:
      return { ...state, isTagCategoryConfigurationLoading: true };
    case types.FETCH_TAG_CATEGORY_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isTagCategoryConfigurationLoading: false,
        tagCategoryConfiguration:
          action.payload?.listTagCategoryConfiguration || [],
      };
    case types.FETCH_TAG_CATEGORY_CONFIGURATION_FAILURE:
      return {
        ...state,
        isTagCategoryConfigurationLoading: false,
        tagCategoryConfiguration: [],
      };

    case types.FETCH_TAG_CATEGORY_CONFIGURATION_BYID_REQUEST:
      return { ...state, isTagCategoryConfigurationLoading: true };
    case types.FETCH_TAG_CATEGORY_CONFIGURATION_BYID_SUCCESS:
      return {
        ...state,
        isTagCategoryConfigurationLoading: false,
        selectedTagCategoryConfiguration: action.payload,
      };
    case types.FETCH_TAG_CATEGORY_CONFIGURATION_BYID_FAILURE:
      return {
        ...state,
        isTagCategoryConfigurationLoading: false,
        selectedTagCategoryConfiguration: null,
      };
    case types.DELETE_WORKLIST_DEFINITION_FAILURE:
    case types.SAVE_TAG_CATEGORY_CONFIGURATION_REQUEST:
      return {
        ...state,
        isTagCategoryConfigurationLoading: true,
        isTagCategoryConfigurationSaved: false,
        tagCategoryConfigurationSaveError: null,
      };
    case types.SAVE_TAG_CATEGORY_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isTagCategoryConfigurationLoading: false,
        isTagCategoryConfigurationSaved: true,
        tagCategoryConfigurationSaveError: null,
      };
    case types.SAVE_TAG_CATEGORY_CONFIGURATION_FAILURE:
      return {
        ...state,
        isTagCategoryConfigurationLoading: false,
        isTagCategoryConfigurationSaved: false,
        tagCategoryConfigurationSaveError: action.payload,
      };

    case types.ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_REQUEST:
      return { ...state, isTagCategoryConfigurationLoading: true };
    case types.ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_SUCCESS:
      return { ...state, isTagCategoryConfigurationLoading: false };
    case types.ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_FAILURE:
      return { ...state, isTagCategoryConfigurationLoading: false };

    case types.FETCH_MANAGE_TAGS_SHELL_REQUEST:
      return { ...state, isManageTagsLoading: true, manageTagsShell: null };
    case types.FETCH_MANAGE_TAGS_SHELL_SUCCESS:
      return {
        ...state,
        isManageTagsLoading: false,
        manageTagsShell: action.payload,
      };
    case types.FETCH_MANAGE_TAGS_SHELL_FAILURE:
      return {
        ...state,
        isManageTagsLoading: false,
        manageTagsShell: null,
        manageTagsSaveError: action.payload,
      };

    case types.FETCH_TAG_ASSIGNMENTS_REQUEST:
      return {
        ...state,
        isAssignmentsLoading: true,
        assignmentEntities: null,
        assignmentRequestKey: `${action.payload.tagID}_${action.payload.resourceTagID}_${action.payload.loadNonce}`,
      };
    case types.FETCH_TAG_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        isAssignmentsLoading: false,
        assignmentEntities: action.payload.data || [],
        assignmentRequestKey: `${action.payload.tagID}_${action.payload.resourceTagID}_${action.payload.loadNonce}`,
      };
    case types.FETCH_TAG_ASSIGNMENTS_FAILURE:
      return {
        ...state,
        isAssignmentsLoading: false,
        assignmentEntities: [],
        assignmentRequestKey: `${action.payload.tagID}_${action.payload.resourceTagID}_${action.payload.loadNonce}`,
      };

    case types.SAVE_MANAGE_TAGS_BATCH_REQUEST:
      return {
        ...state,
        isManageTagsLoading: true,
        isManageTagsSaved: false,
        manageTagsSaveError: null,
      };
    case types.SAVE_MANAGE_TAGS_BATCH_SUCCESS:
      return {
        ...state,
        isManageTagsLoading: false,
        isManageTagsSaved: true,
        manageTagsSaveError: null,
      };
    case types.SAVE_MANAGE_TAGS_BATCH_FAILURE:
      return {
        ...state,
        isManageTagsLoading: false,
        isManageTagsSaved: false,
        manageTagsSaveError: action.payload,
      };

    case types.SAVE_TAG_REQUEST:
      return { ...state, isTagSaved: false, tagSaveError: null };
    case types.SAVE_TAG_SUCCESS:
      return {
        ...state,
        isTagSaved: true,
        tagSaveResult: action.payload,
        tagSaveError: null,
      };
    case types.SAVE_TAG_FAILURE:
      return { ...state, isTagSaved: false, tagSaveError: action.payload };

    case types.DELETE_TAG_REQUEST:
      return { ...state, isTagDeleted: false, tagDeleteError: null };
    case types.DELETE_TAG_SUCCESS:
      return { ...state, isTagDeleted: true, tagDeleteError: null };
    case types.DELETE_TAG_FAILURE:
      return { ...state, isTagDeleted: false, tagDeleteError: action.payload };

    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_REQUEST:
      return { ...state, isWorklistDefinitionConfigurationLoading: true };
    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        worklistDefinitionConfiguration:
          action.payload?.listWorkListDefinitionConfiguration || [],
      };
    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_FAILURE:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        worklistDefinitionConfiguration: [],
      };

    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_REQUEST:
      return { ...state, isWorklistDefinitionConfigurationLoading: true };
    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        worklistDefinitionConfigurationDropdowns: action.payload || {
          siteDropdownItems: [],
          priorityBucketDropdownItems: [],
          subSpecialityDropdownItems: [],
          facilityTagDropdownItems: [],
        },
      };
    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_FAILURE:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        worklistDefinitionConfigurationDropdowns: {
          siteDropdownItems: [],
          priorityBucketDropdownItems: [],
          subSpecialityDropdownItems: [],
          facilityTagDropdownItems: [],
        },
      };

    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_REQUEST:
      return { ...state, isWorklistDefinitionConfigurationLoading: true };
    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        selectedWorklistDefinitionConfiguration: action.payload || null,
      };
    case types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_FAILURE:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        selectedWorklistDefinitionConfiguration: null,
      };

    case types.SAVE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: true,
        isWorklistDefinitionConfigurationSaved: false,
        worklistDefinitionConfigurationSaveError: null,
      };
    case types.SAVE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        isWorklistDefinitionConfigurationSaved: true,
        worklistDefinitionConfigurationSaveError: null,
      };
    case types.SAVE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE:
      return {
        ...state,
        isWorklistDefinitionConfigurationLoading: false,
        isWorklistDefinitionConfigurationSaved: false,
        worklistDefinitionConfigurationSaveError: action.payload,
      };

    case types.DELETE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST:
      return { ...state, isWorklistDefinitionConfigurationLoading: true };
    case types.DELETE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS:
      return { ...state, isWorklistDefinitionConfigurationLoading: false };
    case types.DELETE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE:
      return { ...state, isWorklistDefinitionConfigurationLoading: false };

    case types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST:
      return { ...state, isWorklistDefinitionConfigurationLoading: true };
    case types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS:
      return { ...state, isWorklistDefinitionConfigurationLoading: false };
    case types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE:
      return { ...state, isWorklistDefinitionConfigurationLoading: false };

    //-------------dropdowns in Worklist start ----------------

    // All Master Worklist dropdowns (region, rpce, regional practices)
    case types.DROPDOWN_ALL_MASTER_WORKLIST_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.DROPDOWN_ALL_MASTER_WORKLIST_SUCCESS:
      return {
        ...state,
        isWorkListLoading: false,
        regionDropdown:
          action.payload?.lstRegion || action.payload?.lstRegions || [],
        rpceDropdown: action.payload?.lstRPCE || action.payload?.lstRpce || [],
        regionalPracticeDropdown:
          action.payload?.lstRegionalPractices ||
          action.payload?.lstRegionalPractice ||
          [],
        workListDropdown: {
          RegionDropdownItems:
            action.payload?.lstRegion || action.payload?.lstRegions || [],
          RPCEDropdownItems:
            action.payload?.lstRPCE || action.payload?.lstRpce || [],
        },
        worklistCategoryDropdown:
          action.payload?.lstWorklistCategory ||
          action.payload?.lstWorklistCategories ||
          action.payload?.lstWorklistCategoryMaster ||
          [],
      };
    case types.DROPDOWN_ALL_MASTER_WORKLIST_FAILURE:
      return {
        ...state,
        isWorkListLoading: false,
        regionDropdown: [],
        rpceDropdown: [],
        regionalPracticeDropdown: [],
        workListDropdown: {},
        worklistCategoryDropdown: [],
      };
    //// Get Regional Practice Worklist dropdown
    case types.DROPDOWN_REGIONAL_PRACTICE_WORKLIST_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.DROPDOWN_REGIONAL_PRACTICE_WORKLIST_SUCCESS:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        regionalPracticeWorklistDropdown:
          action.payload?.dropdownItems || action.payload || [],
      };
    case types.DROPDOWN_REGIONAL_PRACTICE_WORKLIST_FAILURE:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        regionalPracticeWorklistDropdown: [],
      };

    //Main Practice
    case types.DROPDOWN_MAIN_PRACTICE_REQUEST:
      return { ...state, isMainPracticeLoading: true };
    case types.DROPDOWN_MAIN_PRACTICE_SUCCESS:
      return {
        ...state,
        isMainPracticeLoading: false,
        MainPractice: action.payload?.dropdownItems || action.payload || [],
      };
    case types.DROPDOWN_MAIN_PRACTICE_FAILURE:
      return { ...state, isMainPracticeLoading: false, MainPractice: [] };

    //-------------dropdowns in Worklist end ----------------

    //-------------------------------------------------------------
    // PRACTICE cases

    case types.FETCH_PRACTICE_REQUEST:
      return { ...state, isPracticeLoading: true };
    case types.FETCH_PRACTICE_SUCCESS:
      return {
        ...state,
        isPracticeLoading: false,
        practices: action.payload?.lstPractice,
      };
    case types.FETCH_PRACTICE_FAILURE:
      return { ...state, isPracticeLoading: false, practices: [] };

    case types.DROPDOWN_WORKLISTDD_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.DROPDOWN_WORKLISTDD_SUCCESS:
      return {
        ...state,
        isWorkListLoading: false,
        workListDropdown: action.payload || [],
      };
    case types.DROPDOWN_WORKLISTDD_FAILURE:
      return { ...state, isWorkListLoading: false, workListDropdown: [] };

    case types.DROPDOWN_REGION_BY_WORKLISTID_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.DROPDOWN_REGION_BY_WORKLISTID_SUCCESS:
      return {
        ...state,
        isWorkListLoading: false,
        regionDropdown: action.payload || [],
      };
    case types.DROPDOWN_REGION_BY_WORKLISTID_FAILURE:
      return { ...state, isWorkListLoading: false, regionDropdown: [] };

    case types.DROPDOWN_MASTER_REGION_REQUEST:
      return { ...state, isRegionDropdownLoading: true };
    case types.DROPDOWN_MASTER_REGION_SUCCESS:
      return {
        ...state,
        isRegionDropdownLoading: false,
        regionDropdownList: action.payload || [],
      };
    case types.DROPDOWN_MASTER_REGION_FAILURE:
      return { ...state, isRegionDropdownLoading: false, regionDropdownList: [] };

    case types.DROPDOWN_MASTER_NATIONAL_REQUEST:
      return { ...state, isNationalDropdownLoading: true };
    case types.DROPDOWN_MASTER_NATIONAL_SUCCESS:
      return {
        ...state,
        isNationalDropdownLoading: false,
        nationalDropdownList: action.payload || [],
      };
    case types.DROPDOWN_MASTER_NATIONAL_FAILURE:
      return { ...state, isNationalDropdownLoading: false, nationalDropdownList: [] };

    case types.SAVE_PRACTICE_REQUEST:
      return { ...state, isPracticeLoading: true };
    case types.SAVE_PRACTICE_SUCCESS:
      return { ...state, isPracticeLoading: false };
    case types.SAVE_PRACTICE_FAILURE:
      return { ...state, isPracticeLoading: false };

    case types.ACTIVATE_DEACTIVATE_PRACTICE_REQUEST:
      return { ...state, isPracticeLoading: true };
    case types.ACTIVATE_DEACTIVATE_PRACTICE_SUCCESS:
      return { ...state, isPracticeLoading: false };
    case types.ACTIVATE_DEACTIVATE_PRACTICE_FAILURE:
      return { ...state, isPracticeLoading: false };

    case types.FETCH_PRACTICE_BY_ID_REQUEST:
      return { ...state, isPracticeLoading: true };
    case types.FETCH_PRACTICE_BY_ID_SUCCESS:
      return {
        ...state,
        isPracticeLoading: false,
        selectedPractice: action.payload,
      };
    case types.FETCH_PRACTICE_BY_ID_FAILURE:
      return { ...state, isPracticeLoading: false, selectedPractice: null };

    //Subpractice cases
    case types.FETCH_SUBPRACTICES_REQUEST:
      return { ...state, isSubpracticeLoading: true };
    case types.FETCH_SUBPRACTICES_SUCCESS:
      return {
        ...state,
        isSubpracticeLoading: false,
        subpractice: action.payload?.lstSubPractice || [],
      };
    case types.FETCH_SUBPRACTICES_FAILURE:
      return { ...state, isSubpracticeLoading: false, subpractice: [] };

    case types.DELETE_SUBPRACTICE_REQUEST:
      return { ...state, isSubpracticeLoading: true };
    case types.DELETE_SUBPRACTICE_SUCCESS:
      return { ...state, isSubpracticeLoading: false };
    case types.DELETE_SUBPRACTICE_FAILURE:
      return { ...state, isSubpracticeLoading: false };

    case types.SAVE_SUBPRACTICE_REQUEST:
      return { ...state, isSubpracticeLoading: true };
    case types.SAVE_SUBPRACTICE_SUCCESS:
      return { ...state, isSubpracticeLoading: false };
    case types.SAVE_SUBPRACTICE_FAILURE:
      return { ...state, isSubpracticeLoading: false };

    case types.FETCH_SUBPRACTICE_BY_ID_REQUEST:
      return { ...state, isSubpracticeLoading: true };
    case types.FETCH_SUBPRACTICE_BY_ID_SUCCESS:
      return {
        ...state,
        isSubpracticeLoading: false,
        selectedSubpractice: action.payload,
      };
    case types.FETCH_SUBPRACTICE_BY_ID_FAILURE:
      return {
        ...state,
        isSubpracticeLoading: false,
        selectedSubpractice: null,
      };

    case types.ACTIVATE_DEACTIVATE_SUBPRACTICE_REQUEST:
      return { ...state, isSubpracticeLoading: true };
    case types.ACTIVATE_DEACTIVATE_SUBPRACTICE_SUCCESS:
      return { ...state, isSubpracticeLoading: false };
    case types.ACTIVATE_DEACTIVATE_SUBPRACTICE_FAILURE:
      return { ...state, isSubpracticeLoading: false };

    case types.DROPDOWN_SUBPRACTICE_REQUEST:
      return { ...state, isSubpracticeLoading: true };
    case types.DROPDOWN_SUBPRACTICE_SUCCESS:
      return {
        ...state,
        isSubpracticeLoading: false,
        subpracticeDropdown: action.payload || [],
      };
    case types.DROPDOWN_SUBPRACTICE_FAILURE:
      return { ...state, isSubpracticeLoading: false, subpracticeDropdown: [] };

    //Section Worklist Mapping cases
    case types.FETCH_SECTIONWORKLIST_REQUEST:
      return { ...state, isSectionWorklistLoading: true };
    case types.FETCH_SECTIONWORKLIST_SUCCESS:
      return {
        ...state,
        isSectionWorklistLoading: false,
        sectionWorklist: action.payload?.listRadSection || [],
      };
    case types.FETCH_SECTIONWORKLIST_FAILURE:
      return { ...state, isSectionWorklistLoading: false, sectionWorklist: [] };

    case types.DELETE_SECTIONWORKLIST_REQUEST:
      return { ...state, isSectionWorklistLoading: true };
    case types.DELETE_SECTIONWORKLIST_SUCCESS:
      return { ...state, isSectionWorklistLoading: false };
    case types.DELETE_SECTIONWORKLIST_FAILURE:
      return { ...state, isSectionWorklistLoading: false };

    case types.SAVE_SECTIONWORKLIST_REQUEST:
      return { ...state, isSectionWorklistLoading: true };
    case types.SAVE_SECTIONWORKLIST_SUCCESS:
      return { ...state, isSectionWorklistLoading: false };
    case types.SAVE_SECTIONWORKLIST_FAILURE:
      return { ...state, isSectionWorklistLoading: false };

    case types.FETCH_SECTIONWORKLIST_BY_ID_REQUEST:
      return { ...state, isSectionWorklistLoading: true };
    case types.FETCH_SECTIONWORKLIST_BY_ID_SUCCESS:
      return {
        ...state,
        isSectionWorklistLoading: false,
        selectedSectionWorklist: action.payload,
      };
    case types.FETCH_SECTIONWORKLIST_BY_ID_FAILURE:
      return {
        ...state,
        isSectionWorklistLoading: false,
        selectedSectionWorklist: null,
      };

    case types.ACTIVATE_DEACTIVATE_SECTIONWORKLIST_REQUEST:
      return { ...state, isSectionWorklistLoading: true };
    case types.ACTIVATE_DEACTIVATE_SECTIONWORKLIST_SUCCESS:
      return { ...state, isSectionWorklistLoading: false };
    case types.ACTIVATE_DEACTIVATE_SECTIONWORKLIST_FAILURE:
      return { ...state, isSectionWorklistLoading: false };

    case types.DROPDOWN_SECTIONWORKLIST_REQUEST:
      return { ...state, isSectionWorklistLoading: true };
    case types.DROPDOWN_SECTIONWORKLIST_SUCCESS:
      return {
        ...state,
        isSectionWorklistLoading: false,
        sectionWorklistDropdown: action.payload || [],
      };
    case types.DROPDOWN_SECTIONWORKLIST_FAILURE:
      return {
        ...state,
        isSectionWorklistLoading: false,
        sectionWorklistDropdown: [],
      };

    //UserManagement cases
    case types.FETCH_USERMANAGEMENT_REQUEST:
      return { ...state, isUserManagementLoading: true };
    case types.FETCH_USERMANAGEMENT_SUCCESS:
      return {
        ...state,
        isUserManagementLoading: false,
        userManagement: action.payload?.listRadUser || [],
      };
    case types.FETCH_USERMANAGEMENT_FAILURE:
      return { ...state, isUserManagementLoading: false, userManagement: [] };

    case types.DELETE_USERMANAGEMENT_REQUEST:
      return { ...state, isUserManagementLoading: true };
    case types.DELETE_USERMANAGEMENT_SUCCESS:
      return { ...state, isUserManagementLoading: false };
    case types.DELETE_USERMANAGEMENT_FAILURE:
      return { ...state, isUserManagementLoading: false };

    case types.SAVE_USERMANAGEMENT_REQUEST:
      return { ...state, isUserManagementLoading: true };
    case types.SAVE_USERMANAGEMENT_SUCCESS:
      return { ...state, isUserManagementLoading: false };
    case types.SAVE_USERMANAGEMENT_FAILURE:
      return { ...state, isUserManagementLoading: false };

    case types.FETCH_USERMANAGEMENT_BY_ID_REQUEST:
      return { ...state, isUserManagementLoading: true };
    case types.FETCH_USERMANAGEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isUserManagementLoading: false,
        selectedUserManagement: action.payload?.selectedUserManagement || null,
        userManagementRole: action.payload?.userManagementRole || {
          dropdownItems: [],
        },
        userManagementDesignation: action.payload
          ?.userManagementDesignation || { dropdownItems: [] },
        tenantDropdown: action.payload?.tenantDropdown || { dropdownItems: [] },
      };
    case types.FETCH_USERMANAGEMENT_BY_ID_FAILURE:
      return {
        ...state,
        isUserManagementLoading: false,
        selectedUserManagement: null,
        userManagementRole: { dropdownItems: [] },
        userManagementDesignation: { dropdownItems: [] },
        tenantDropdown: { dropdownItems: [] },
      };

    case types.RESET_USER_MFA_REQUEST:
      return { ...state, isResetMfaLoading: true };
    case types.RESET_USER_MFA_SUCCESS:
      return { ...state, isResetMfaLoading: false };
    case types.RESET_USER_MFA_FAILURE:
      return { ...state, isResetMfaLoading: false };

    // case types.DROPDOWN_TENANTS_REQUEST:
    //     return { ...state, isUserManagementLoading: true };
    // case types.DROPDOWN_TENANTS_SUCCESS:
    //     return { ...state, isUserManagementLoading: false, tenantDropdown: action.payload || [] };
    // case types.DROPDOWN_TENANTS_FAILURE:
    //     return { ...state, isUserManagementLoading: false, tenantDropdown: [] };

    // case types.DROPDOWN_USER_REGIONAL_PRACTICE_REQUEST:
    //     return { ...state, isUserManagementLoading: true };
    // case types.DROPDOWN_USER_REGIONAL_PRACTICE_SUCCESS:
    //     return { ...state, isUserManagementLoading: false, userRegionalPracticeDropdown: action.payload || [] };
    // case types.DROPDOWN_USER_REGIONAL_PRACTICE_FAILURE:
    //     return { ...state, isUserManagementLoading: false, userRegionalPracticeDropdown: [] };

    // case types.DROPDOWN_USER_MAIN_PRACTICE_REQUEST:
    //     return { ...state, isUserManagementLoading: true };
    // case types.DROPDOWN_USER_MAIN_PRACTICE_SUCCESS:
    //     return { ...state, isUserManagementLoading: false, userMainPracticeDropdown: action.payload || [] };
    // case types.DROPDOWN_USER_MAIN_PRACTICE_FAILURE:
    //     return { ...state, isUserManagementLoading: false, userMainPracticeDropdown: [] };

    //HolidayPlanner cases
    case types.FETCH_HOLIDAY_PLANNER_REQUEST:
      return { ...state, isHolidayPlannerLoading: true };
    case types.FETCH_HOLIDAY_PLANNER_SUCCESS:
      return {
        ...state,
        isHolidayPlannerLoading: false,
        holidayPlanner: action.payload?.listOfholidays || [],
      };
    case types.FETCH_HOLIDAY_PLANNER_FAILURE:
      return { ...state, isHolidayPlannerLoading: false, holidayPlanner: [] };

    case types.DELETE_HOLIDAY_PLANNER_REQUEST:
      return { ...state, isHolidayPlannerLoading: true };
    case types.DELETE_HOLIDAY_PLANNER_SUCCESS:
      return { ...state, isHolidayPlannerLoading: false };
    case types.DELETE_HOLIDAY_PLANNER_FAILURE:
      return { ...state, isHolidayPlannerLoading: false };

    case types.SAVE_HOLIDAY_PLANNER_REQUEST:
      return { ...state, isHolidayPlannerLoading: true };
    case types.SAVE_HOLIDAY_PLANNER_SUCCESS:
      return { ...state, isHolidayPlannerLoading: false };
    case types.SAVE_HOLIDAY_PLANNER_FAILURE:
      return { ...state, isHolidayPlannerLoading: false };

    case types.ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_REQUEST:
      return { ...state, isHolidayPlannerLoading: true };
    case types.ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_SUCCESS:
      return { ...state, isHolidayPlannerLoading: false };
    case types.ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_FAILURE:
      return { ...state, isHolidayPlannerLoading: false };

    case types.HOLIDAY_PLANNER_BULK_UPDATE_REQUEST:
      return { ...state, isHolidayPlannerLoading: true };
    case types.HOLIDAY_PLANNER_BULK_UPDATE_SUCCESS:
      return { ...state, isHolidayPlannerLoading: false };
    case types.HOLIDAY_PLANNER_BULK_UPDATE_FAILURE:
      return { ...state, isHolidayPlannerLoading: false };

    //Holiday Demand Planner cases
    case types.FETCH_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.FETCH_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        HolidayDemandPlanner: action.payload || [],
      };
    case types.FETCH_HOLIDAY_DEMANDPLANNER_FAILURE:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        HolidayDemandPlanner: [],
      };

    case types.Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return { ...state, isHolidayDemandPlannerLoading: false };
    case types.Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE:
      return { ...state, isHolidayDemandPlannerLoading: false };

    case types.BULK_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST:
      return {
        ...state,
        isHolidayDemandPlannerLoading: true,
        holidayDemandPlannerSaveResponse: null,
      };
    case types.BULK_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        holidayDemandPlannerSaveResponse: {
          success: true,
          data: action.payload,
        },
      };
    case types.BULK_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        holidayDemandPlannerSaveResponse: {
          success: false,
          error: action.payload,
        },
      };

    case types.FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        RecentTrendHolidayDemandPlanner: action.payload || [],
      };
    case types.FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_FAILURE:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        RecentTrendHolidayDemandPlanner: [],
      };

    case types.FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        PastTrendHolidayDemandPlanner: action.payload || [],
      };
    case types.FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_FAILURE:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        PastTrendHolidayDemandPlanner: [],
      };

    case types.FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_SUCCESS:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        selectedHolidayDemandPlanner: action.payload || [],
      };
    case types.FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_FAILURE:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        selectedHolidayDemandPlanner: [],
      };

    case types.UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return {
        ...state,
        isHolidayDemandPlannerLoading: false,
        uploadResponse: action.payload,
      };
    case types.UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE:
      return { ...state, isHolidayDemandPlannerLoading: false };

    case types.LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return { ...state, isHolidayDemandPlannerLoading: false };
    case types.LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE:
      return { ...state, isHolidayDemandPlannerLoading: false };

    case types.DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST:
      return { ...state, isHolidayDemandPlannerLoading: true };
    case types.DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS:
      return { ...state, isHolidayDemandPlannerLoading: false };
    case types.DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE:
      return { ...state, isHolidayDemandPlannerLoading: false };

    //Regional Practice Worklist cases
    case types.FETCH_REGIONAL_PRACTICE_WORKLIST_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.FETCH_REGIONAL_PRACTICE_WORKLIST_SUCCESS:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        regionalPracticeWorklist:
          action.payload?.lstSchedulingRegionalPracticeWorklists || [],
      };
    case types.FETCH_REGIONAL_PRACTICE_WORKLIST_FAILURE:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        regionalPracticeWorklist: [],
      };

    case types.DELETE_REGIONAL_PRACTICE_WORKLIST_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.DELETE_REGIONAL_PRACTICE_WORKLIST_SUCCESS:
      return { ...state, isRegionalPracticeWorklistLoading: false };
    case types.DELETE_REGIONAL_PRACTICE_WORKLIST_FAILURE:
      return { ...state, isRegionalPracticeWorklistLoading: false };

    case types.SAVE_REGIONAL_PRACTICE_WORKLIST_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.SAVE_REGIONAL_PRACTICE_WORKLIST_SUCCESS:
      return { ...state, isRegionalPracticeWorklistLoading: false };
    case types.SAVE_REGIONAL_PRACTICE_WORKLIST_FAILURE:
      return { ...state, isRegionalPracticeWorklistLoading: false };

    case types.FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_SUCCESS:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        selectedRegionalPracticeWorklist: action.payload,
      };
    case types.FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_FAILURE:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        selectedRegionalPracticeWorklist: null,
      };

    case types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_SUCCESS:
      return { ...state, isRegionalPracticeWorklistLoading: false };
    case types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_FAILURE:
      return { ...state, isRegionalPracticeWorklistLoading: false };

    case types.DROPDOWN_REGIONAL_PRACTICE_REQUEST:
      return { ...state, isRegionalPracticeWorklistLoading: true };
    case types.DROPDOWN_REGIONAL_PRACTICE_SUCCESS:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        regionalPracticeDropdown: action.payload || [],
      };
    case types.DROPDOWN_REGIONAL_PRACTICE_FAILURE:
      return {
        ...state,
        isRegionalPracticeWorklistLoading: false,
        regionalPracticeDropdown: [],
      };

    //----------Main Practice Cases----------//
    case types.FETCH_MAIN_PRACTICE_REQUEST:
      return { ...state, isMainPracticeLoading: true };
    case types.FETCH_MAIN_PRACTICE_SUCCESS:
      return {
        ...state,
        isMainPracticeLoading: false,
        MainPractice: action.payload?.lstMainPractices || [],
      };
    case types.FETCH_MAIN_PRACTICE_FAILURE:
      return { ...state, isMainPracticeLoading: false, MainPractice: [] };

    case types.FETCH_MAIN_PRACTICE_DROPDOWNLIST_REQUEST:
      return { ...state, isMaindropdownloading: true };
    case types.FETCH_MAIN_PRACTICE_DROPDOWNLIST_SUCCESS:
      return {
        ...state,
        isMaindropdownloading: false,
        DropdownDDList: action.payload?.dropdownItems || [],
      };
    case types.FETCH_MAIN_PRACTICE_DROPDOWNLIST_FAILURE:
      return { ...state, isMaindropdownloading: false, DropdownDDList: [] };

    case types.GET_MAIN_PRACTICE_BY_ID_REQUEST:
      return { ...state, isMainPracticeLoading: true };
    case types.GET_MAIN_PRACTICE_BY_ID_SUCCESS:
      return {
        ...state,
        isMainPracticeLoading: false,
        selectedMainPractice: action.payload,
      };
    case types.GET_MAIN_PRACTICE_BY_ID_FAILURE:
      return {
        ...state,
        isMainPracticeLoading: false,
        selectedMainPractice: null,
      };

    case types.SAVE_MAIN_PRACTICE_REQUEST:
      return { ...state, isMainPracticeLoading: true };
    case types.SAVE_MAIN_PRACTICE_SUCCESS:
      return { ...state, isMainPracticeLoading: false };
    case types.SAVE_MAIN_PRACTICE_FAILURE:
      return { ...state, isMainPracticeLoading: false };

    case types.DELETE_MAIN_PRACTICE_REQUEST:
      return { ...state, isMainPracticeLoading: true };
    case types.DELETE_MAIN_PRACTICE_SUCCESS:
      return { ...state, isMainPracticeLoading: false };
    case types.DELETE_MAIN_PRACTICE_FAILURE:
      return { ...state, isMainPracticeLoading: false };

    case types.ACTIVATE_DEACTIVATE_MAIN_PRACTICE_REQUEST:
      return { ...state, isMainPracticeLoading: true };
    case types.ACTIVATE_DEACTIVATE_MAIN_PRACTICE_SUCCESS:
      return { ...state, isMainPracticeLoading: false };
    case types.ACTIVATE_DEACTIVATE_MAIN_PRACTICE_FAILURE:
      return { ...state, isMainPracticeLoading: false };

    // Regional Practice cases
    case types.FETCH_REGIONAL_PRACTICE_REQUEST:
      return { ...state, isRegionalPracticeLoading: true };
    case types.FETCH_REGIONAL_PRACTICE_SUCCESS:
      return {
        ...state,
        isRegionalPracticeLoading: false,
        RegionalPractice: action.payload || [],
      };
    case types.FETCH_REGIONAL_PRACTICE_FAILURE:
      return {
        ...state,
        isRegionalPracticeLoading: false,
        regionalPractice: [],
      };
    case types.DELETE_REGIONAL_PRACTICE_REQUEST:
      return { ...state, isRegionalPracticeLoading: true };
    case types.DELETE_REGIONAL_PRACTICE_SUCCESS:
      return { ...state, isRegionalPracticeLoading: false };
    case types.DELETE_REGIONAL_PRACTICE_FAILURE:
      return { ...state, isRegionalPracticeLoading: false };
    case types.SAVE_REGIONAL_PRACTICE_REQUEST:
      return { ...state, isRegionalPracticeLoading: true };
    case types.SAVE_REGIONAL_PRACTICE_SUCCESS:
      return { ...state, isRegionalPracticeLoading: false };
    case types.SAVE_REGIONAL_PRACTICE_FAILURE:
      return { ...state, isRegionalPracticeLoading: false };
    case types.FETCH_REGIONAL_PRACTICE_BY_ID_REQUEST:
      return { ...state, isRegionalPracticeLoading: true };
    case types.FETCH_REGIONAL_PRACTICE_BY_ID_SUCCESS:
      return {
        ...state,
        isRegionalPracticeLoading: false,
        selectedRegionalPractice: action.payload,
      };
    case types.FETCH_REGIONAL_PRACTICE_BY_ID_FAILURE:
      return {
        ...state,
        isRegionalPracticeLoading: false,
        selectedRegionalPractice: null,
      };
    case types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_REQUEST:
      return { ...state, isRegionalPracticeLoading: true };
    case types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_SUCCESS:
      return { ...state, isRegionalPracticeLoading: false };
    case types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_FAILURE:
      return { ...state, isRegionalPracticeLoading: false };

    //common cases
    case types.UPDATE_ADMIN_REDUCER:
      return { ...state, ...action.payload };

    // WorkList full save
    case types.SAVE_WORKLIST_FULL_REQUEST:
      return { ...state, isWorkListLoading: true };
    case types.SAVE_WORKLIST_FULL_SUCCESS:
      return { ...state, isWorkListLoading: false };
    case types.SAVE_WORKLIST_FULL_FAILURE:
      return { ...state, isWorkListLoading: false };

    default:
      return state;
  }
};

export default regionReducer;
